import ApiClient from "~/admin/services/ApiClient";

export default class DemandsApi {
  static getNb = () => ApiClient.get("demands/number");
}
